import Cookies from "universal-cookie";
import { api } from "../services/api";
import axios from "axios";
import { message } from "antd";

export function storeTokenInLocalStorage(token) {
    localStorage.setItem('token', token);
}

export function getTokenFromLocalStorage() {
    return localStorage.getItem('token');
}


export function switchProfile() {
    localStorage.clear();
}

export function setUserLocal(user) {
    localStorage.setItem("user", JSON.stringify(user));

}

export function getUserLocal() {
    const userLocal = localStorage.getItem("user");

    if (!userLocal) return false;

    const user = JSON.parse(userLocal);

    return user ?? null;
}

export function setProfileLocal(profileData) {
    localStorage.setItem("profile", JSON.stringify(profileData));
}

export function setCoursesLocal(coursesData) {
    localStorage.setItem("courses", JSON.stringify(coursesData));
}

export function getProfileLocal() {

    const profileLocal = localStorage.getItem("profile");

    if (!profileLocal) return false;

    const profile = JSON.parse(profileLocal);

    return profile ?? null;
}

export const goToProfile = async (user) => {
    try {
        const { data } = await api.post(`/authenticate-as`,
            {
                role_id: user?.role_id,
                franchise_hash: user?.franchise_hash,
            }
        );

        return data;
    } catch (error) {
        console.log(error);
        return false
    }
}



export async function clearCookies() {

    const deleteAllCookies = () => {
        const cookies = document.cookie.split(";");

        for (const cookie of cookies) {
            const eqPos = cookie.indexOf("=");
            const name = eqPos > -1 ? cookie.substr(0, eqPos) : cookie;
            document.cookie = name + "=;expires=Thu, 01 Jan 1970 00:00:00 GMT";
        }
    }


    new Promise((resolve) => {
        resolve(
            setTimeout(() => {
                const cookies = new Cookies();

                const all = cookies.getAll();

                Object.keys(all).forEach((key) => {
                    cookies.remove(`${key}`, {
                        path: "/",
                    });
                });

                deleteAllCookies()
            }, 500)
        );

        localStorage.clear();

    });

    return

}


export async function getSession() {
    try {
        await api.get("/api/auth", {
            withCredentials: true,
            headers: {
                xsrfCookieName: "XSRF-TOKEN",
                xsrfHeaderName: "X-XSRF-TOKEN",
            },
        });

        return true;
    } catch (error) {
        return false;
    }
}


export async function LoginRequest(email, password) {
    // Configura o axios para enviar cookies em todas as requisições
    axios.defaults.withCredentials = true;

    try {
        // Obtém o CSRF cookie
        await api.get("/sanctum/csrf-cookie");

        try {
            const { data } = await api.post("/login", { email, password });
            return data;
        } catch (error) {
            console.log(error)

            message.error("Login ou senha incorretos");

            return false

        }
    } catch (error) {
        console.log(error);
        message.error("Ocorreu um erro ao tentar se autenticar", 10);
    }
}


export function isValidCPF(cpf) {
    // Validar se é String
    if (typeof cpf !== "string") return false;

    // Tirar formatação
    cpf = cpf.replace(/[^\d]+/g, "");

    // Validar se tem tamanho 11 ou se é uma sequência de digitos repetidos
    if (cpf.length !== 11 || !!cpf.match(/(\d)\1{10}/)) return false;

    // String para Array
    cpf = cpf.split("");

    const validator = cpf
        // Pegar os últimos 2 digitos de validação
        .filter((digit, index, array) => index >= array.length - 2 && digit)
        // Transformar digitos em números
        .map((el) => +el);

    const toValidate = (pop) =>
        cpf
            // Pegar Array de items para validar
            .filter((digit, index, array) => index < array.length - pop && digit)
            // Transformar digitos em números
            .map((el) => +el);

    const rest = (count, pop) =>
        ((toValidate(pop)
            // Calcular Soma dos digitos e multiplicar por 10
            .reduce((soma, el, i) => soma + el * (count - i), 0) *
            10) %
            // Pegar o resto por 11
            11) %
        // transformar de 10 para 0
        10;

    return !(rest(10, 2) !== validator[0] || rest(11, 1) !== validator[1]);
}